import React from 'react';
import '../App.css';
import Navbar from './navbar/Navbar';
import Secoundheader from "./header/Secoundheader";
import Project from "./project/Project";
import CourseSyllabus from "./CourseSyllabus/CourseSyllabus";
import Tools from "./tools/Tools";
import Trainers from "./trainers/Trainers";
import Placement from "./placement/Placement";
import Testimonial from "./testimonial/Testimonial";
import Upcoming from "./upcomingbatches/Upcoming";
import OurClient from "./ourclient/Ourclient";
import ServicesSection from "./servicessection/Servicesection";
import FAQ from "./faq/FAQ";
import Contact from "./contact/Contact";
import Footer from "./footer/Footer";
import OurClients from './ourclient/Ourclient';
import ScrollToTop from '../ScrollToTop';
import FooterAll from '../footer/Footer';


function Mainazurecomponents() {
  return (
    <>
        <ScrollToTop/>
      {/* Navigation Headers */}
      <Navbar />
      <Secoundheader />

      {/* Course Core Modules */}
      <Project />
      <CourseSyllabus />
      <Tools />
      <Trainers />
      <Placement />

      {/* Social Proof & Practical Features */}
      <Testimonial />
      <Upcoming />
      <OurClients />
      <ServicesSection />

      {/* Support Layout Footer Sections */}
      <FAQ />
      <Contact />
      <FooterAll />
    </>
  );
}

export default Mainazurecomponents;